import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MainPage from "./pages/MainPage";
import AllTournamentPage from "./pages/AllTournamentPage";
import WatchingPage from "./pages/WatchingPage";
import "./styles/App.css";

// VERSION 1.0.0
const API_BASE_URL = 'https://api.scoutncvf.com';
export { API_BASE_URL };

function App() {
  const [allTournament, setAllTournament] = useState([]);
  const [watching, setWatching] = useState([]);
  const [teams, setTeams] = useState([]); // Store team metadata only
  const [dbStatus, setDbStatus] = useState(null);
  const [showDbStatus, setShowDbStatus] = useState(true); // State to control visibility
  const [isLoading, setIsLoading] = useState(true); // State to track loading status

  useEffect(() => {
    const checkDatabaseConnection = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/health-check`);
        if (!response.ok) {
          throw new Error('Failed to connect to the database');
        }
        const data = await response.json();
        setDbStatus(data.message); // Set the success message
        setShowDbStatus(true); // Show the status indicator

        // Hide the database status message after 2 seconds
        setTimeout(() => {
          setShowDbStatus(false);
        }, 2000);

        // Fetch team metadata after database connection is established
        fetchTeams();
      } catch (error) {
        console.error('Error checking database connection:', error.message);
        setDbStatus('Failed to connect to the database'); // Set the error message
        setShowDbStatus(true); // Show the status indicator
        setIsLoading(false); // Stop loading if there's an error
      }
    };

    // Fetch team metadata (lightweight)
    const fetchTeams = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/teams`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setTeams(data);
        setIsLoading(false); // Data is fully loaded
      } catch (error) {
        console.error('Error fetching teams:', error.message);
        setIsLoading(false); // Stop loading if there's an error
      }
    };

    checkDatabaseConnection();
  }, []);

  return (
    <Router>
      <div className="app">
        {showDbStatus && dbStatus && (
          <div className={`db-status ${dbStatus.includes('Failed') ? 'error' : 'success'}`}>
            {dbStatus}
          </div>
        )}
        {isLoading ? (
          // Show loading message while data is being fetched
          <div className="loading-message">Loading data...</div>
        ) : (
          // Render the main app content after data is loaded
          <div className="main-content">
            <nav className="navbar">
              <Link to="/">Main Page</Link>
              <Link to="/watching">Watching</Link>
              <Link to="/all-tournament">All Tournament</Link>
            </nav>
            <Routes>
              <Route
                path="/"
                element={
                  <MainPage
                    allTournament={allTournament}
                    setAllTournament={setAllTournament}
                    watching={watching}
                    setWatching={setWatching}
                    teams={teams}
                  />
                }
              />
              <Route
                path="/all-tournament"
                element={
                  <AllTournamentPage
                    allTournament={allTournament}
                    setAllTournament={setAllTournament}
                  />
                }
              />
              <Route
                path="/watching"
                element={<WatchingPage watching={watching} setWatching={setWatching} />}
              />
            </Routes>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
